import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';

interface Props {
  variants?: 'solid';
  paddings?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    variants: { default: undefined },
    paddings: { default: 'px-2 py-1' }
  },
  setup(__props: any) {

const props = __props as { variants: 'solid', paddings: string }


const mixedClasses = computed(() => {
  switch (props.variants) {
    case 'solid':
      return 'bg-primary text-white';
    default:
      return 'bg-green-light text-primary font-medium';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rounded text-sm inline-block", [_unref(mixedClasses), __props.paddings]])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})